import { render, staticRenderFns } from "./CultureAboutJinqiaoFormType.vue?vue&type=template&id=aa29c060&scoped=true&"
import script from "./CultureAboutJinqiaoFormType.vue?vue&type=script&lang=js&"
export * from "./CultureAboutJinqiaoFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa29c060",
  null
  
)

export default component.exports